import React from 'react'
import { Box, Button, Flex, Heading, Spinner } from '@chakra-ui/react'
import { AddIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom'
import useCanManageResearch from '../../../hooks/useCanManageResearch'
import { useResearch } from './hooks/useResearch'
import ResearchFilter from './components/ResearchFilter'
import ResearchList from './components/ResearchList'

const ResearchPage = () => {
  const canManageResearch = useCanManageResearch()
  const {
    research,
    tags,
    filteredResearch,
    loading,
    searchTerm,
    selectedTags,
    selectedLetter,
    setSearchTerm,
    setSelectedTags,
    handleLetterClick,
  } = useResearch()

  if (loading) {
    return (
      <Box
        p={6}
        display='flex'
        justifyContent='center'
        alignItems='center'
        minH='200px'
      >
        <Spinner size='xl' />
      </Box>
    )
  }

  return (
    <Box p={6}>
      <Flex justifyContent='space-between' alignItems='center' mb={6}>
        <Heading size='lg'>Research Directory</Heading>
        {canManageResearch && (
          <Button
            as={Link}
            to='/research/add'
            leftIcon={<AddIcon />}
            colorScheme='blue'
            size='sm'
          >
            Add Research
          </Button>
        )}
      </Flex>

      <ResearchFilter
        tags={tags}
        searchTerm={searchTerm}
        selectedTags={selectedTags}
        selectedLetter={selectedLetter}
        onSearchChange={setSearchTerm}
        onTagsChange={(values) => setSelectedTags(values as string[])}
        onLetterClick={handleLetterClick}
      >
        <ResearchList
          filteredResearch={filteredResearch}
          totalResearch={research.length}
          tags={tags}
        />
      </ResearchFilter>
    </Box>
  )
}

export default ResearchPage
